const isString = arg => typeof arg === 'string';
const isArray = arg => Array.isArray(arg);
const isMixedTypeArray = array =>
  isArray(array) && !(array.every(isArray) || array.every(isString));

const examples = {
  SIMPLE: ['practice'],
  AND: ['practice', 'certifications'],
  OR: [['practice'], ['certifications']],
};

const generateInvalidFeaturesDetail = features => {
  return [
    'Recieved features ',
    JSON.stringify(features),
    `\n\nSupported features formats\n${Object.keys(examples)
      .map(key => `  • ${key} ${JSON.stringify(examples[key])}`)
      .join('\n')}`,
  ].join('');
};

class FeatureFlagError extends Error {
  constructor(message, detail) {
    super(message);
    this.name = 'FeatureFlagError';
    console.error(`${this.name}: ${message}\n\n`, detail);
  }
}

export const getFeaturesFlags = () => {
  // eslint-disable-next-line no-underscore-dangle
  return global.__LLY_FEATURE_FLAGS__ || {};
};

export const hasFeatureFlags = (features = []) => {
  const enabledFeatures = getFeaturesFlags();
  let requiredFeatures = features;
  if (isString(features)) {
    requiredFeatures = [[features]];
  } else if (isArray(features) && features.every(isString)) {
    requiredFeatures = [features];
  }

  if (isMixedTypeArray(features)) {
    // If you encounter this issue, look here for more usage information
    // https://about.lessonly.engineering/styleguide/react/#featureflag-interface--in-transition---frontend-experiment
    throw new FeatureFlagError(
      'Invalid features format',
      generateInvalidFeaturesDetail(features),
    );
  }

  return requiredFeatures.some(required =>
    required.every(featureKey => enabledFeatures[featureKey]),
  );
};
